import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';
import { GenericPoolItem } from '.';
import { REQUEST_POOL, REQUEST_POOL_FAILURE, REQUEST_POOL_SUCCESS } from './pools.actionTypes';

export const actionCreators = {
	doRequestPool: (selectedPool: PoolEnumType) => ({
		type: REQUEST_POOL,
		selectedPool,
	}),
	doRequestPoolSuccess: (selectedPool: PoolEnumType, items: GenericPoolItem[]) => ({
		type: REQUEST_POOL_SUCCESS,
		selectedPool,
		items,
	}),
	doRequestPoolFailure: (selectedPool: any, error?: Error) => ({
		type: REQUEST_POOL_FAILURE,
		selectedPool,
		error,
	}),
};

export type PoolsActionType =
	| ReturnType<typeof actionCreators.doRequestPool>
	| ReturnType<typeof actionCreators.doRequestPoolSuccess>
	| ReturnType<typeof actionCreators.doRequestPoolFailure>;
